import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../configHelper';

interface iRequisitionStatusHistoryDataService {
  getRequisitionStatusHistoryListById(string): any;
}

@Injectable({
  providedIn: 'root'
})
export class RequisitionStatusHistoryDataService implements iRequisitionStatusHistoryDataService {

  constructor(private httpClient: HttpClient, private configService: ConfigService) { 
  }

  public getRequisitionStatusHistoryListById(id: string): any {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/RequisitionStatusHistory/GetReqStatusListByReqId/?reqid=${id}`;
    return this.httpClient.get(url);
  }

}
